import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ChromePicker } from 'react-color';
import { connect } from 'react-redux';
import {
  Button,
  Label,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { canUserManageShare } from '../../helpers/Share';
import { userHasFeature } from '../../helpers/Features';

import HelpIcon from '../HelpIcon';
import UpgradePlanButton from '../UpgradePlanButton';

const ShareModalColor = ({
  handleChange,
  color,
  workspaceColor,
}) => {
  const [colorPickerOpened, setColorPickerOpened] = useState(false);
  const [localColor, setLocalColor] = useState(null);

  const intl = useIntl();

  const canManageShare = canUserManageShare();

  useEffect(() => {
    setLocalColor(color);
  }, [color]);

  return (
    <div className="share-color share-setting form-inline">
      <Label>
        <span>
          {intl.formatMessage({ defaultMessage: 'Color' })}
          <HelpIcon id="share-color">
            {intl.formatMessage({ defaultMessage: 'Set color for share.' })}
          </HelpIcon>
        </span>
      </Label>
      <div>
        {(color && canManageShare) && (
          <Button
            color="link"
            onClick={() => handleChange(null)}
            size="sm"
          >
            {intl.formatMessage({ defaultMessage: 'Reset' })}
          </Button>
        )}
        <div className="share-setting-switch-wrapper">
          <UpgradePlanButton feature="share-custom-branding" simple={true} />
          {userHasFeature('share-custom-branding') && (
            <div className={classnames('color-button', { 'color-button-disabled': !canManageShare })}>
              <div
                onClick={() => {
                  if (canManageShare) {
                    setColorPickerOpened(true);
                  }
                }}
                aria-hidden="true"
              >
                <div className="color-button-content" style={{ backgroundColor: !color ? workspaceColor : color }} />
              </div>
              {canManageShare && colorPickerOpened && (
                <div className="color-picker-popover">
                  <div className="color-picker-cover" onClick={() => { setColorPickerOpened(false); }} aria-hidden="true" />
                  <ChromePicker
                    color={!localColor ? workspaceColor : localColor}
                    disableAlpha={true}
                    onChange={(c) => {
                      setLocalColor(c.hex);
                    }}
                    onChangeComplete={(c) => {
                      handleChange(c.hex);
                    }}
                  />
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  workspaceColor: state.App.settings.color,
});

ShareModalColor.propTypes = {
  color: PropTypes.string,
  workspaceColor: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
};

ShareModalColor.defaultProps = {
  color: null,
};

export default connect(mapStateToProps)(ShareModalColor);
